import React from "react";
import wellnessDashboardImage from "../assets/wellness-dashboard.jpg";

const PersonalizedWellness = () => (
  <>
    <style>{`
      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(50px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .wellness-header {
        animation: slideInUp 0.8s ease-out;
      }

      .wellness-image {
        animation: slideInRight 0.8s ease-out 0.2s both;
      }

      .wellness-feature {
        animation: slideInUp 0.6s ease-out;
        transition: all 0.4s ease;
      }

      .wellness-feature:nth-child(1) { animation-delay: 0.2s; }
      .wellness-feature:nth-child(2) { animation-delay: 0.3s; }
      .wellness-feature:nth-child(3) { animation-delay: 0.4s; }

      @keyframes bounce {
        0%, 100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-12px);
        }
      }

      .wellness-icon {
        animation: bounce 2s ease-in-out infinite;
      }

      .wellness-feature:nth-child(1) .wellness-icon { animation-delay: 0s; }
      .wellness-feature:nth-child(2) .wellness-icon { animation-delay: 0.2s; }
      .wellness-feature:nth-child(3) .wellness-icon { animation-delay: 0.4s; }
      .wellness-feature:nth-child(4) .wellness-icon { animation-delay: 0.6s; }

      .wellness-feature:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(34, 197, 94, 0.15);
      }
    `}</style>

    <section id="wellness" className="py-24 bg-gradient-to-br from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16 wellness-header">
          <span className="inline-flex items-center gap-2 bg-emerald-100 border border-emerald-300 rounded-full px-4 py-2 text-xs font-semibold text-[#1A7A7A] mb-6">
            <span className="w-2 h-2 bg-[#1A7A7A] rounded-full" />
            Wellness & Prevention
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Personalized Health Planning & Predictive Care
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            Track your health holistically with AI-powered wellness plans tailored to your lifestyle and health goals.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            {[
              {
                icon: "📸",
                title: "Visual Meal Tracking",
                desc: "Upload photos of your meals and drinks. Our AI analyzes nutritional content automatically."
              },
              {
                icon: "🍎",
                title: "Personalized Diet Plans",
                desc: "Get customized nutrition plans based on your health goals and dietary preferences."
              },
              {
                icon: "🏃",
                title: "Tailored Exercise Routines",
                desc: "AI-generated workout plans tailored to your fitness level and available time."
              },
              {
                icon: "⚠️",
                title: "Predictive Health Monitoring",
                desc: "Advanced analytics to predict and monitor risks for diabetes, hypertension, and cancer."
              }
            ].map((feature, idx) => (
              <div key={idx} className="wellness-feature bg-white rounded-xl p-6 shadow-lg border border-emerald-100 hover:border-emerald-300">
                <div className="flex items-start gap-4">
                  <div className="text-4xl wellness-icon">{feature.icon}</div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-gray-600">{feature.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="wellness-image">
            <img 
              src={wellnessDashboardImage} 
              alt="Your Health Dashboard" 
              className="w-full rounded-2xl shadow-xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  </>
);

export default PersonalizedWellness;
